import 'react-app-polyfill/stable'
import 'core-js'
// import 'localstorage-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
// import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store, persistor } from './store/index'
import { PersistGate } from 'redux-persist/integration/react'
import history from './module/history'
import SocketProvider from './containers/SocketProvider'

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { ErrorBoundary } from 'react-error-boundary';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import PageError from './components/PageError'
import ProcessProvider from 'src/components/ProgressPanel/index'
import { NotificationProvider } from './context/NotificationContext'
import AppWrapper from './AppWrapper'
import { isDevelopment } from './module/helpers'

const queryClient = new QueryClient();


const charAT = `

 █████╗ ██╗██████╗  █████╗ ███╗   ██╗    ██████╗ ███████╗██╗   ██╗
██╔══██╗██║██╔══██╗██╔══██╗████╗  ██║    ██╔══██╗██╔════╝██║   ██║
███████║██║██║  ██║███████║██╔██╗ ██║    ██║  ██║█████╗  ██║   ██║
██╔══██║██║██║  ██║██╔══██║██║╚██╗██║    ██║  ██║██╔══╝  ╚██╗ ██╔╝
██║  ██║██║██████╔╝██║  ██║██║ ╚████║    ██████╔╝███████╗ ╚████╔╝ 
╚═╝  ╚═╝╚═╝╚═════╝ ╚═╝  ╚═╝╚═╝  ╚═══╝    ╚═════╝ ╚══════╝  ╚═══╝  
 `;
console.info(`%c${charAT}`, 'color: #5BE49B');

// registerPlugin(
//   FilePondPluginImageExifOrientation,
//   FilePondPluginImagePreview,
//   FilePondPluginFileEncode,
//   FilePondPluginFileValidateType,
// )

const CHUNK_RELOAD_KEY = "billing_chunk_reload_at";
const CHUNK_RELOAD_COOLDOWN = 30_000;

const getErrorMessage = (error) => {
  const candidates = [
    error?.message,
    error?.reason?.message,
    error?.name,
    typeof error === "string" ? error : "",
  ];

  return candidates
    .filter(Boolean)
    .join(" ");
};

const isChunkLoadError = (error) => {
  const message = getErrorMessage(error);

  return (
    error?.name === "ChunkLoadError" ||
    /ChunkLoadError/i.test(message) ||
    /Loading chunk [\w-]+ failed/i.test(message) ||
    /Loading CSS chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
};

const getLastReloadTime = () => {
  try {
    return Number(
      window.sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0
    );
  } catch {
    return 0;
  }
};

const setLastReloadTime = (time) => {
  try {
    window.sessionStorage.setItem(CHUNK_RELOAD_KEY, String(time));
    return true;
  } catch {
    return false;
  }
};

let chunkReloadStarted = false;

const reloadAfterChunkError = (error) => {
  if (!isChunkLoadError(error)) return;

  console.error("[ChunkLoadError] Gagal memuat asset aplikasi.", {
    message: getErrorMessage(error),
    url: window.location.href,
    time: new Date().toISOString(),
  });

  // Jangan menjalankan reload berkali-kali pada halaman yang sama.
  if (chunkReloadStarted) return;

  const now = Date.now();
  const lastReload = getLastReloadTime();

  // Hindari reload loop lintas pemuatan halaman.
  if (
    lastReload > 0 &&
    now - lastReload >= 0 &&
    now - lastReload < CHUNK_RELOAD_COOLDOWN
  ) {
    console.error(
      "[ChunkLoadError] Reload ditahan karena cooldown aktif."
    );
    return;
  }

  chunkReloadStarted = true;
  setLastReloadTime(now);

  window.location.reload();
};

window.addEventListener("unhandledrejection", (event) => {
  reloadAfterChunkError(event.reason);
});

window.addEventListener("error", (event) => {
  reloadAfterChunkError(event.error || event.message);
});


const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}



ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={loading} persistor={persistor}>
      <NotificationProvider>
        <QueryClientProvider client={queryClient}>
          <SocketProvider>
            <ProcessProvider>
              <ErrorBoundary FallbackComponent={PageError}>
                <AppWrapper history={history} />
              </ErrorBoundary>
            </ProcessProvider>
          </SocketProvider>
        </QueryClientProvider>
      </NotificationProvider>
    </PersistGate>
  </Provider>
  ,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// if (process.env.NODE_ENV === 'production') {
//   serviceWorkerRegistration.register();
// }

const isFCMSupported =
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "Notification" in window;

if (process.env.NODE_ENV === 'production' && isFCMSupported) {
  serviceWorkerRegistration.unregister();
}




if (process.env?.NODE_ENV === "development" && isFCMSupported)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        if (isDevelopment)
          console.log('FCM Service Worker registered:', registration);
      })
      .catch((err) => {
        console.error('FCM Service Worker registration failed:', err);
      });
  }

// window.setFcmToken = (payload) => {

//   const { token, source } = payload;
//   console.log("[ANDROID] FCM Token received:", token);
//   localStorage.setItem("fcm_token_android", token);

//   window.dispatchEvent(new Event("fcm-token-ready"));
// };

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
reportWebVitals()